import { apiErrorCodes } from 'consts/api/apiErrorCodes';
import { commonTexts, settlementTexts } from 'consts/text';
import { getErrorMessageAndCode } from 'utils/errorHandlers/getErrorMessageAndCode';

export const childDiscountsErrorParser = (error: unknown) => {
    const { code } = getErrorMessageAndCode(error);

    if (code === apiErrorCodes.OVERLAPPING_DISCOUNT_EXIST) {
        return settlementTexts.discounts.overlappingDiscountErrorMessage;
    }

    return commonTexts.errorMessages.actionExecution;
};
